/* ============================================
   AANYA Scroll Reveal Observer
   Adds .is-visible to .aanya-reveal elements
   when they enter the viewport
   ============================================ */

(function() {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.aanya-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05,
    rootMargin: '0px 0px 50px 0px'
  });

  function initReveal() {
    document.querySelectorAll('.aanya-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
